
const Blocking = ["block", "advert"];
const Bonus = ["1", "2", "3", "4", "5"];
const PlaceTypes: Record<string, string> = {
    "#": "block",
    "_": "road",
    "*": "decoration",
    "A": "advert"
}

interface IPlace {
    type: string
}

export class Place {
    private readonly _bonus?: number;
    private readonly _type: string;

    constructor(private props: IPlace) {
        if (Bonus.includes(props.type)) {
            const bonus = parseInt(props.type);

            this._bonus = Number.isInteger(bonus) ? bonus : undefined;
            this._type = "bonus";
        } else {
            this._type = PlaceTypes[props.type] ?? "block";
        }
    }

    get blocking() {
        return Blocking.includes(this._type);
    }

    get bonus() {
        return this._bonus;
    }

    get type() {
        return this._type;
    }
}
